import React from 'react';
import { makeStyles } from "@material-ui/core";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import ShareIcon from '@material-ui/icons/Share';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';

const useStyles = makeStyles((theme) => ({
    cardBlock: {
        marginBottom: 20,
        backgroundColor: '#fff',
        borderRadius: 4,
        padding: 15,
        paddingTop: 20,
        paddingBottom: 20
    },
    cardMainHeading: {
        fontWeight: 'bold',
        fontSize: 15,
        margin: 0,
        paddingBottom: 14
    },
    totalTestDesc: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 14,
        paddingBottom: 14,
        borderBottom: '1px solid #eee'
    },
    desc: {
        color: '#8E9598',
        fontSize: 13,
        flex: 1
    },
    bottomBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    date: {
        color: '#8E9598',
        fontSize: 13,
    },
    sharingSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    sharingText: {
        marginLeft: 5,
        color: '#8E9598',
        fontSize: 12
    },
    sharingIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 20,
        '& svg': {
            fill: '#8E9598',
            width: 14,
            height: 14
        }
    }
}));
const NotificationCard = props => {
    const t = useTranslations();
    const classes = useStyles();

    return (
        <>
          <div className={classes.cardBlock}>
                <h4 className={classes.cardMainHeading}>Rajasthan Home Guard Recruitment 2021:Apply Online for Rajasthan Constable posts!</h4>
                <div className={classes.totalTestDesc}>
                    <span className={classes.desc}>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.</span>
                </div>
                <div className={classes.bottomBar}>
                    <span className={classes.date}>25 Nov, 2021</span>
                    <div className={classes.sharingSection}>
                        <div className={classes.sharingIcon}>
                            <ShareIcon />
                            <span className={classes.sharingText}>{t('Share')}</span>
                        </div>
                        <div className={classes.sharingIcon}>
                            <BookmarkBorderIcon />
                            <span className={classes.sharingText}>{t('Save')}</span>
                        </div>
                    </div>
                </div>
          </div>
        </>
    );
};
export default NotificationCard;